import { PREMIUM_FEATURE_NAMES } from '../../constants';
import {
  TABS_DICTIONARY,
  OLD_TASKS_TAB_NAME,
  SHIFT_TASKS_TAB_NAME,
  TASK_TEMPLATES_TAB_NAME,
} from '../constants';

export default class ShiftTasksTabsService {
  constructor(Authentication, ShiftTasksService) {
    'ngInject';

    Object.assign(this, { Authentication, ShiftTasksService });

    const { isManager } = this.Authentication.user;
    this.tabs = this.getTabs(isManager);
    this.currentTab = this.getDefaultTab(this.tabs, ShiftTasksService.oldTasksUsed, isManager);
  }

  getTabs(isManager) {
    return isManager ? this.getManagerNavigationTabs() : this.getEmployeeNavigationTabs();
  }

  getEmployeeNavigationTabs() {
    const { areOldTasksEnabled, isFeatureEnabled, oldTasksUsed } = this.ShiftTasksService;
    const tabs = [];

    if (areOldTasksEnabled && oldTasksUsed) {
      tabs.push({ ...TABS_DICTIONARY[OLD_TASKS_TAB_NAME] });
    }

    if (isFeatureEnabled) {
      tabs.push({
        ...TABS_DICTIONARY[SHIFT_TASKS_TAB_NAME],
        premiumFeature: PREMIUM_FEATURE_NAMES.shiftTasks,
      });
    }

    return tabs;
  }

  getManagerNavigationTabs() {
    const { areOldTasksEnabled, oldTasksUsed } = this.ShiftTasksService;
    const tabs = [];

    if (areOldTasksEnabled && oldTasksUsed) {
      tabs.push({ ...TABS_DICTIONARY[OLD_TASKS_TAB_NAME] });
    }

    tabs.push({ ...TABS_DICTIONARY[SHIFT_TASKS_TAB_NAME] });
    tabs.push({ ...TABS_DICTIONARY[TASK_TEMPLATES_TAB_NAME] });

    return tabs;
  }

  getDefaultTab(tabs, oldTasksUsed, isManager) {
    const lastTab = this.getLastTab(tabs);
    if (lastTab) {
      return lastTab;
    }

    const oldTaskTab = tabs.find((tab) => tab.value === OLD_TASKS_TAB_NAME);
    if (oldTasksUsed && oldTaskTab) {
      return oldTaskTab;
    }

    const taskTemplatesTab = tabs.find((tab) => tab.value === TASK_TEMPLATES_TAB_NAME);
    const shiftTasksTab = tabs.find((tab) => tab.value === SHIFT_TASKS_TAB_NAME);

    return isManager ? taskTemplatesTab : shiftTasksTab;
  }

  getLastTab(tabs) {
    const lastTabId = this.Authentication.user.clientcache.taskInstances?.tab;
    if (lastTabId) {
      return tabs.find((tab) => tab.value === lastTabId);
    }
  }

  shouldDisplayTabs() {
    return this.tabs.length > 1;
  }

  setTabByValue(value) {
    const currentTab = this.tabs.find((tab) => tab.value === value);
    if (currentTab) {
      this.currentTab = currentTab;
      if (this.Authentication.user.clientcache.taskInstances) {
        this.Authentication.user.clientcache.taskInstances.tab = value;
        this.Authentication.syncClientCache();
      }
    }
    return currentTab;
  }
}
